// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module('frontDoorPage')
  .directive('giNavOnSelect', ($window, siteMap) => ({
    restrict: 'A',

    link(scope, element, attrs) {
      $(element)
        .find('option')
        .each(function () {
          const optionUrl = $(this).attr(attrs.giNavOnSelect);
          if (
            siteMap.cleanRelativePath(optionUrl) === $window.location.pathname
          ) {
            return $(this).prop('selected', 'selected');
          }
        });

      return $(element).on(
        'change',
        () =>
          ($window.location.href = $(element)
            .find(':selected')
            .attr(attrs.giNavOnSelect))
      );
    },
  }));
